exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-image[data-v-5af589b6]{width:100%;max-width:64px;-o-object-fit:contain;object-fit:contain}.full-description[data-v-5af589b6]{font-size:.85rem;white-space:normal;line-height:1.5rem;text-overflow:ellipsis;overflow:hidden}.el-select-dropdown__item[data-v-5af589b6]{height:72px!important}li.el-select-dropdown__item.item-result[data-v-5af589b6]{border-bottom:1px solid #e0e6f8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5af589b6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/items/ItemSearchQuickSale.vue
// module id = I9d/
// module chunks = 0